import { useEffect, useRef, useState } from 'react'

/** En dessous de ce seuil la barre reste toujours visible (haut de page). */
const TOP_ZONE_PX = 80

/** Amplitude minimale avant de considérer un changement de direction : évite que
 *  le rebond élastique iOS ou un micro-mouvement du doigt fasse clignoter la barre. */
const DIRECTION_THRESHOLD_PX = 8

/**
 * `true` quand l'utilisateur descend la page : la barre collante des résultats
 * s'escamote alors et réapparaît dès qu'il remonte.
 *
 * Volontairement séparé de {@link useScrollInfo}, qui pose un état à CHAQUE
 * événement de scroll : ici l'état ne change qu'aux inversions de direction,
 * donc le composant collant ne se re-rend pas à chaque pixel.
 */
export function useHideOnScrollDown(): boolean {
  const [hidden, setHidden] = useState(false)
  const lastScrollY = useRef(0)

  useEffect(() => {
    lastScrollY.current = window.scrollY

    const handleScroll = () => {
      const currentY = window.scrollY
      const delta = currentY - lastScrollY.current

      if (currentY <= TOP_ZONE_PX) {
        lastScrollY.current = currentY
        setHidden(false)
        return
      }

      if (Math.abs(delta) < DIRECTION_THRESHOLD_PX) return

      lastScrollY.current = currentY
      setHidden(delta > 0)
    }

    window.addEventListener('scroll', handleScroll, { passive: true })
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [])

  return hidden
}
